import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const FullScreenSlideUpModal = ({ isOpen, onClose, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem("isCollapsed") === "true"
  );

  useEffect(() => {
    const handleStorageChange = () => {
      const collapsed = localStorage.getItem("isCollapsed") === "true";
      setIsCollapsed(collapsed);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const sidebarWidth = isCollapsed
    ? "clamp(3.5rem,5vw,5rem)"
    : "clamp(12rem,15vw,16rem)";

  return (
    <motion.div
      key="slide-up-modal"
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: "100%", opacity: 0 }}
      transition={{
        type: "spring",
        stiffness: 180,
        damping: 24,
        duration: 0.3,
      }}
      // 🔧 Fix: remove overflow-y-auto here
      className="fixed top-0 z-[1000] h-full bg-custom-bg-light-purple shadow-lg overflow-hidden"
      style={{
        left: sidebarWidth,
        width: `calc(100% - ${sidebarWidth})`,
      }}
    >
      {/* === Layout Wrapper === */}
      <div className="flex flex-col h-full">
        {/* Close Button */}
        <div className="flex bg-custom-bg-light-purple justify-end p-fluid-2 border-b">
          <button
            onClick={onClose}
            className="text-fluid-xl font-bold text-gray-600 hover:text-gray-900"
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>

        {/* Modal Content (scrollable area) */}
        <div className="flex-1 overflow-y-auto bg-custom-bg-light-purple px-fluid-3 pb-fluid-[-1]">
          {children}
        </div>
      </div>
    </motion.div>
  );
};

export default FullScreenSlideUpModal;
